import React, { useState, useEffect, useRef } from "react";
import "./Mov.css";

const Mov = () => {
	const [imageOne, setImageOne] = useState(500);
	const [imagetwo, setImagetwo] = useState(500);
	const [imagethree, setImagethree] = useState(500);
	const [isExpanded, setIsExpanded] = useState(false);
	const img1Ref = useRef(null);
	const img2Ref = useRef(null);
	const img3Ref = useRef(null);

	useEffect(() => {
		const handleScroll = () => {
			const el = document.querySelector(".movDiv");
			const textEl = document.querySelector(".movText");

			if (
				!el ||
				!textEl ||
				!img1Ref.current ||
				!img2Ref.current ||
				!img3Ref.current
			)
				return;

			const screenBottom = window.innerHeight;
			const elPos = el.getBoundingClientRect().top;

			if (elPos < screenBottom && elPos + 150 > 0) {
				textEl.style.visibility = "visible";
				textEl.style.opacity = "1";
				textEl.style.transform = "translateX(0)";
			} else {
				textEl.style.visibility = "hidden";
				textEl.style.opacity = "0";
				textEl.style.transform = "translateX(-300px)";
			}

			const updateImage = (rect, setter) => {
				setter(rect.bottom - 50 < screenBottom ? 0 : 500);
			};

			updateImage(img1Ref.current.getBoundingClientRect(), setImageOne);
			updateImage(img2Ref.current.getBoundingClientRect(), setImagetwo);
			updateImage(img3Ref.current.getBoundingClientRect(), setImagethree);
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		<div className='mov'>
			<div className='movText'>
				<h2>Die Freiheit des Fliegens</h2>
				<p className={`p-text ${isExpanded ? "expanded" : ""}`}>
					Vom majestätischen Blick auf schneebedeckte Bergspitzen bis zu weiten
					Wiesen und Tälern – unsere Flüge bieten dir eine atemberaubende
					Aussicht auf die Natur. Jeder Flug ist ein Fenster in die Welt der
					unberührten Landschaften, die du aus einer völlig neuen Perspektive
					erleben kannst.
				</p>
				<ul>
					<li>Atemberaubende Aussichten bereits ab wenigen Metern</li>
					<li>Ideal für Flugbegeisterte & als Geschenk</li>
					<li>Sicherer Startplatz in Becherbach</li>
					<li>Moderne Ausrüstung & erfahrener Pilot</li>
				</ul>
			</div>
			<img
				ref={img1Ref}
				style={{ transform: `translateX(${imageOne}%)` }}
				id='img1'
				src='./img/bilder/mov.png'
				alt='paraglider'
				className='image1'
			/>
			<img
				ref={img2Ref}
				style={{ transform: `translateX(${imagetwo}%)` }}
				id='img2'
				src='./img/bilder/mov3.png'
				alt=''
				className='image2'
			/>
			<img
				ref={img3Ref}
				style={{ transform: `translateX(${imagethree}%)` }}
				id='img3'
				src='./img/bilder/mov2.png'
				alt=''
				className='image3'
			/>
		</div>
	);
};

export default Mov;
